// import { makeRequest } from 'src/utils/graphql';
// import { QUERY_HEADER } from '../queries';
// import { DesignerEntity } from 'src/modules/designers';
import { HeaderStore } from './types';
// import { ProductCategoryEntity, ProductEntity } from 'src/modules/products';
// import { ArticleCategoryEntity, ArticleEntity } from 'src/modules/articles';
// import { PageEntity } from 'src/modules/pages';
import headerData from 'public/data/header.json';

export enum HeaderActions {
  SetData = 'HEADER/SetData',
  FetchDataBegin = 'HEADER/FETCH_DATA/BEGIN',
  FetchDataSuccess = 'HEADER/FETCH_DATA/SUCCESS',
  FetchDataError = 'HEADER/FETCH_DATA/ERROR',
  UpdateHeroBox = 'HEADER/HERO/BOX',
}

export const setHeaderData = (data: Partial<HeaderStore>) => ({
  type: HeaderActions.SetData,
  payload: data,
});

export const fetchHeaderData = (_outputChannel) => {
  return async (dispatch) => {
    await dispatch(fetchHeaderDataBegin());

    try {
      // const response = await makeRequest<{
      //   navigation: {
      //     products: ProductEntity[];
      //     europe_url: string;
      //     australia_url: string;
      //     usa_url: string;
      //   };
      //   designersLeft: DesignerEntity[];
      //   designersRight: DesignerEntity[];
      //   productCategories: ProductCategoryEntity[];
      //   articleCategories: ArticleCategoryEntity[];
      //   aboutPage: PageEntity;
      //   professionalsPage: PageEntity;
      //   articles: ArticleEntity[];
      // }>(QUERY_HEADER, {
      //   outputChannel,
      // });

      const response = headerData;

      const products = response?.navigation?.products;
      const europe_url = response?.navigation?.europe_url;
      const australia_url = response?.navigation?.australia_url;
      const usa_url = response?.navigation?.usa_url;

      await dispatch(
        fetchHeaderDataSuccess({
          designers: response?.designersLeft,
          designerCards: response?.designersRight,
          products: products,
          productCategories: response?.productCategories,
          articleCategories: response?.articleCategories,
          aboutPage: response?.aboutPage,
          professionalsPage: response?.professionalsPage,
          articles: response?.articles,
          europe_url: europe_url,
          australia_url: australia_url,
          usa_url: usa_url,
        })
      );
    } catch (e) {
      console.error(e);
      await dispatch(fetchHeaderDataError({ message: e.message }));
    }
  };
};

const fetchHeaderDataBegin = () => ({
  type: HeaderActions.FetchDataBegin,
});

const fetchHeaderDataSuccess = (results) => {
  return {
    type: HeaderActions.FetchDataSuccess,
    payload: results,
  };
};

const fetchHeaderDataError = (error) => ({
  type: HeaderActions.FetchDataError,
  payload: { error },
});

export interface UpdateHeroBoxArgs {
  height: number;
}

export const updateHeroBox = (box: UpdateHeroBoxArgs | null) => {
  return {
    type: HeaderActions.UpdateHeroBox,
    payload: box,
  };
};
